import React from 'react';
import { Helmet } from 'react-helmet-async';

import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';

import favicon from 'assets/img/favicon.png';

const Meta = () => {
  const t = useTranslate(TranslationNamespace.APP);

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <meta content="IE=edge" httpEquiv="X-UA-Compatible" />
      <meta
        content="width=device-width, initial-scale=1, viewport-fit=cover"
        name="viewport"
      />
      <meta content={t('description')} name="description" />
      <meta content={t('description')} property="og:description" />
      <link crossOrigin="" href="https://assets.hover.to" rel="preconnect" />
      <link crossOrigin="" href="https://graph.hover.to" rel="preconnect" />
      <link href={favicon} rel="icon" />
    </Helmet>
  );
};

export { Meta };
